import {BulkProducts, StorageSeason} from "src/model/ProductMatch";
import {
    ADD_PRODUCT,
    BulkProductAction,
    DEL_ALL_PRODUCTS,
    DEL_PRODUCT, UPDATE_ALL_PRODUCTS,
    UPDATE_PRODUCT,
    UPDATE_PROGRAMS,
    UPDATE_STORAGE_SEASON
} from "src/actions/BulkProductAction";
import {PROGRAM_NAME_OF_FBA} from "src/config/Config";

const initialState: BulkProducts = {
    products: [],
    programs: [PROGRAM_NAME_OF_FBA],
    storageSeason: new Date().getMonth() < 9 ? StorageSeason.NON_PEAK : StorageSeason.PEAK
};

export default (
    state: BulkProducts = initialState,
    action: BulkProductAction
): BulkProducts => {
    switch (action.type) {
        case ADD_PRODUCT:
            return {
                ...state,
                products: [...state.products, action.product]
            };
        case DEL_PRODUCT:
            return {
                ...state,
                products: state.products.filter(product => product !== action.product)
            };
        case UPDATE_PRODUCT:
            const productList = state.products.map(p => {
                return p == action.oldProduct ? action.product : p;
            })
            return {
                ...state,
                products: productList
            };
        case UPDATE_ALL_PRODUCTS:
            return {
                ...state,
                products: action.products
            };
        case DEL_ALL_PRODUCTS:
            return {
                ...state,
                products: []
            };
        case UPDATE_STORAGE_SEASON:
            return {
                ...state,
                storageSeason: action.storageSeason
            };
        case UPDATE_PROGRAMS:
            return {
                ...state,
                programs: action.programs
            };
        default:
            return state;
    }
};

